import { render, staticRenderFns } from "./extras.vue?vue&type=template&id=74e8ed86&lang=html&"
import script from "./extras.vue?vue&type=script&lang=js&"
export * from "./extras.vue?vue&type=script&lang=js&"
import style0 from "./extras.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports